import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import BodyFont from '../Theme/Fonts/Body'
import { TestID } from '../utils/PropTypesDefinitions'

type ErrorScreenProps = {
    errorMessage: string
    errorIcon?: 'error' | 'wifi-problem'
    type?: 'small' | 'big'
} & TestID

const ErrorScreen: FunctionComponent<ErrorScreenProps> = ({
    errorMessage,
    type = 'small',
    errorIcon = 'error',
    testID,
}): ReactElement => {
    const isSmall = type === 'small'
    return (
        <Grid center noExpand testID={testID} backgroundColor="pearl">
            <FontelloIcon
                name={errorIcon}
                fontSize={isSmall ? 30 : 106}
                marginBottom={isSmall ? 3 : 40}
                color="onyx"
            />
            <BodyFont color="onyx" textAlign="center" bold>
                {errorMessage}
            </BodyFont>
        </Grid>
    )
}

export default memo(ErrorScreen)
